/**
 * Helpers de estado de onboarding artista.
 *
 * Fuente de verdad: users.is_artist en BD (se setea true al completar el paso 4
 * del ArtistOnboardingStepper). Esto funciona cross-device porque vive en el
 * servidor, no en localStorage del dispositivo.
 *
 * Fallback de compatibilidad: raios_artist_setup_completed en localStorage
 * para usuarios que completaron onboarding antes de la migracion — el flag
 * local sigue siendo valido hasta que Redux cargue user.is_artist desde BD.
 *
 * raios_artist_banner_dismissed se mantiene: es decision del usuario no-artista
 * de ocultar el banner, independiente de si completo onboarding.
 */

/**
 * @param {Object|null} user - Usuario de Redux (auth.user)
 * @returns {boolean} true si el setup de artista esta completo
 */
export function is_artist_setup_complete(user) {
  if (user?.is_artist === true) return true;
  if (typeof window !== 'undefined' && window.localStorage) {
    return Boolean(window.localStorage.getItem('raios_artist_setup_completed'));
  }
  return false;
}

/**
 * @returns {boolean} true si el usuario eligio esconder el banner de onboarding
 */
export function is_banner_dismissed() {
  if (typeof window !== 'undefined' && window.localStorage) {
    return Boolean(window.localStorage.getItem('raios_artist_banner_dismissed'));
  }
  return false;
}

/**
 * Estado compuesto que usa Navbar: ocultar banner si completo O dismisseo.
 * @param {Object|null} user - Usuario de Redux
 * @returns {boolean}
 */
export function should_hide_onboarding_banner(user) {
  return is_artist_setup_complete(user) || is_banner_dismissed();
}
